import React from "react";
import cx from "classnames";
import { Field } from "formik";
import styles from "./Checkbox.module.scss";

export interface CheckboxProps {
  label: string | React.ReactNode;
  name: string;
  disabled?: boolean;
  value?: string;
  theme?: "light" | "dark";
}

const View = ({
  label,
  name,
  disabled,
  value,
  theme = "light",
}: CheckboxProps) => {
  return (
    <label
      className={cx(styles.checkbox, "inline-flex gap-x-2 items-center", {
        "text-gray-500 cursor-default": disabled,
        "text-gray-700 cursor-pointer": !disabled,
      })}
    >
      <Field
        className={cx({ [styles.dark]: theme === "dark" })}
        name={name}
        type="checkbox"
        disabled={disabled}
        value={value}
      />
      {label}
    </label>
  );
};

export default View;
